var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',_vm._l((_vm.breadcrumb),function(item,index){return _c('a-breadcrumb-item',{key:index},[(typeof item === 'string')?_c('span',[_vm._v(_vm._s(item))]):(!item.path)?_c('span',[_vm._v(_vm._s(item.name))]):_c('span',{staticClass:"link",on:{"click":function($event){return _vm.linkPath(item, index)}}},[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }